module.exports = __webpack_public_path__ + "media/images/social-share-button/hacker_news-ab31bea068d7c9b3292b61e520498491.svg";